import AgeticIcon from './AgeticIcon.vue'
import AbsibIcon from './AbsibIcon.vue'
import AgeticSimpleIcon from './AgeticSimpleIcon.vue'
import AbsibSimpleIcon from './AbsibSimpleIcon.vue'
import BarraIcon from './BarraIcon.vue'
import BarraSimpleIcon from './BarraSimpleIcon.vue'
import BookmarkIcon from './BookmarkIcon.vue'
import DownIcon from './DownIcon.vue'
import DownloadIcon from './DownloadIcon.vue'
import FileIcon from './FileIcon.vue'
import FileSimpleIcon from './FileSimpleIcon.vue'
import FullIScreenIcon from './FullIScreenIcon.vue'
import PrintIcon from './PrintIcon.vue'
import SearchIcon from './SearchIcon.vue'
import UpIcon from './UpIcon.vue'
import ZoomInIcon from './ZoomInIcon.vue'
import ZoomOutIcon from './ZoomOutIcon.vue'

export {
  AgeticIcon,
  AbsibIcon,
  AgeticSimpleIcon,
  AbsibSimpleIcon,
  FileSimpleIcon,
  BarraIcon,
  BarraSimpleIcon,
  BookmarkIcon,
  DownIcon,
  DownloadIcon,
  FileIcon,
  FullIScreenIcon,
  PrintIcon,
  SearchIcon,
  UpIcon,
  ZoomInIcon,
  ZoomOutIcon
}
